import { z } from 'zod'

export const schema = z.object({
  deals: z.array(
    z.object({
      id: z.string(),
      slug: z.string(),
      cottageId: z.string(),
      provinceName: z.string(),
      title: z.string().optional().nullable(),
      description: z.string(),
      priceNew: z.object({
        amount: z.number().int(),
        currency: z.string(),
      }),
      priceOld: z.object({
        amount: z.number().int(),
        currency: z.string(),
      }),
      pricePersonNight: z.object({
        amount: z.number().int(),
        currency: z.string(),
      }),
      discountPercent: z.number(),
      nights: z.number().int(),
      numPersons: z.number().int(),
      dateIn: z.string(),
      dateOut: z.string(),
      imageUrl: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
